import { Button } from '@/components/ui/button';
import { Plus, Minus } from 'lucide-react';

interface ZoomControlsProps {
  zoomLevel: number;
  onZoomChange: (level: number) => void;
}

const ZOOM_LEVELS = [75, 85, 100, 115, 125, 150];

export const ZoomControls = ({ zoomLevel, onZoomChange }: ZoomControlsProps) => {
  const currentIndex = ZOOM_LEVELS.indexOf(zoomLevel);
  const canZoomOut = currentIndex > 0;
  const canZoomIn = currentIndex < ZOOM_LEVELS.length - 1;

  const handleZoomOut = () => {
    if (canZoomOut) {
      onZoomChange(ZOOM_LEVELS[currentIndex - 1]);
    }
  };

  const handleZoomIn = () => {
    if (canZoomIn) {
      onZoomChange(ZOOM_LEVELS[currentIndex + 1]);
    }
  };

  const handleReset = () => {
    onZoomChange(100);
  };

  return (
    <div className="flex items-center gap-0.5">
      <Button
        variant="ghost"
        size="icon"
        onClick={handleZoomOut}
        disabled={!canZoomOut}
        className="h-6 w-6 p-0"
      >
        <Minus className="h-3 w-3" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        onClick={handleZoomIn}
        disabled={!canZoomIn}
        className="h-6 w-6 p-0"
      >
        <Plus className="h-3 w-3" />
      </Button>
    </div>
  );
};
